(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutEnvelope'] = {
  "react": [
    [
      "div",
      "wrapper",
      [
        "_wrapper"
      ],
      {},
      [
        "label",
        "firstNameFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "label",
        "lastNameFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "label",
        "emailFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "label",
        "phoneFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "div",
        null,
        [
          "_container"
        ],
        {},
        [
          "div",
          null,
          [
            "_bg"
          ],
          {},
          [
            "h1",
            "formTitle",
            [],
            {}
          ],
          [
            "div",
            null,
            [
              "_table"
            ],
            {},
            [
              "div",
              null,
              [
                "_table-row"
              ],
              {},
              [
                "ul",
                null,
                [
                  "_table-cell"
                ],
                {},
                [
                  "li",
                  null,
                  [
                    "_table-view"
                  ],
                  {},
                  [
                    "div",
                    null,
                    [],
                    {},
                    [
                      "span",
                      "firstNameRow",
                      [
                        "_row"
                      ],
                      {},
                      [
                        "input",
                        "firstNameField",
                        [],
                        {
                          "type": "text",
                          "placeholder": "First name",
                          "name": "firstName"
                        }
                      ]
                    ],
                    [
                      "span",
                      "lastNameRow",
                      [
                        "_row"
                      ],
                      {},
                      [
                        "input",
                        "lastNameField",
                        [],
                        {
                          "type": "text",
                          "placeholder": "Last name",
                          "name": "lastName"
                        }
                      ]
                    ]
                  ]
                ],
                [
                  "li",
                  "phoneRow",
                  [
                    "_row"
                  ],
                  {},
                  [
                    "div",
                    "phoneField",
                    [
                      "_phoneField"
                    ],
                    {},
                    [
                      "span",
                      null,
                      [
                        "_drop-list"
                      ],
                      {},
                      [
                        "input",
                        "selected",
                        [
                          "_selected"
                        ],
                        {
                          "type": "text",
                          "name": "code",
                          "data-skip-placeholder": true
                        }
                      ],
                      [
                        "span",
                        null,
                        [
                          "_after"
                        ],
                        {},
                        [
                          "svg",
                          null,
                          [],
                          {
                            "version": "1.1",
                            "xmlns": "http://www.w3.org/2000/svg",
                            "width": "15px",
                            "height": "7.634px",
                            "viewBox": "0 0 12.854 7.634"
                          },
                          [
                            "polygon",
                            null,
                            [],
                            {
                              "fill": "#FFFFFF",
                              "points": "11.658,0 6.427,5.231 1.197,0 0,1.197 5.231,6.427 5.221,6.437 6.417,7.634 6.427,7.624 7.624,6.427 12.854,1.197 "
                            }
                          ]
                        ]
                      ],
                      [
                        "select",
                        "countryCodesField",
                        [],
                        {
                          "data-skip-placeholder": true
                        }
                      ]
                    ],
                    [
                      "div",
                      null,
                      [
                        "_forPhone"
                      ],
                      {},
                      [
                        "input",
                        "phoneNumberField",
                        [],
                        {
                          "type": "phone",
                          "name": "phone",
                          "placeholder": "Phone number"
                        }
                      ]
                    ]
                  ]
                ],
                [
                  "li",
                  "emailRow",
                  [
                    "_row"
                  ],
                  {},
                  [
                    "span",
                    null,
                    [],
                    {},
                    [
                      "input",
                      "emailField",
                      [],
                      {
                        "name": "email",
                        "type": "email",
                        "placeholder": "enter your e-mail address"
                      }
                    ]
                  ]
                ]
              ],
              [
                "div",
                null,
                [
                  "_table-cell"
                ],
                {},
                [
                  "em",
                  "phoneMessage",
                  [],
                  {}
                ],
                [
                  "div",
                  null,
                  [
                    "_button"
                  ],
                  {},
                  [
                    "button",
                    "submit",
                    [],
                    {}
                  ]
                ]
              ]
            ]
          ],
          [
            "div",
            "notifications",
            [],
            {}
          ]
        ]
      ],
      [
        "div",
        "message",
        [
          "_message"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": false,
    "successMessageOutside": true
  },
  "params": {
    "webThemeDir": "URL",
    "bg3": "BG_COLOR_ALPHA",
    "tfnt": "FONT",
    "titleColor": "TEXT_COLOR",
    "efnt": "FONT",
    "txtError": "BORDER_COLOR",
    "txt1": "TEXT_COLOR",
    "bg1": "BG_COLOR_ALPHA",
    "fnt": "FONT",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "labelTxt": "TEXT_COLOR",
    "txt2": "TEXT_COLOR",
    "fnt2": "FONT",
    "bg2": "BG_COLOR_ALPHA",
    "txt3": "TEXT_COLOR",
    "bg4": "BG_COLOR_ALPHA",
    "txtSuccess": "TEXT_COLOR",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "webThemeDir": "WEB_THEME_DIRECTORY",
    "bg3": "color_12",
    "tfnt": "font_6",
    "titleColor": "color_15",
    "efnt": "font_9",
    "txtError": "#8b0000",
    "txt1": "color_15",
    "bg1": "color_11",
    "fnt": "font_9",
    "brw": "1px",
    "brd": "color_12",
    "labelTxt": "color_12",
    "txt2": "color_11",
    "fnt2": "font_9",
    "bg2": "color_19",
    "txt3": "color_15",
    "bg4": "color_18",
    "txtSuccess": "#bada55",
    "maxbrw": [
      "brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:505px;min-height:126px;max-width:980px;max-height:1024px;",
    "%wrapper%_wrapper": "width:100%;box-sizing:border-box;position:relative;",
    "%wrapper%_wrapper %_container": "border:25px solid transparent;-webkit-border-image:url([webThemeDir]subscribeform/envelope-border.png) 25 round;border-image:url([webThemeDir]subscribeform/envelope-border.png) 25 round;box-sizing:border-box;position:relative;",
    "%wrapper%_wrapper %_container:before": "content:\"\";position:absolute;top:-10px;right:-10px;bottom:-10px;left:-10px;display:block;background-color:#fff;",
    "%wrapper%_wrapper %_container %_bg": "margin:-5px;padding:30px 24px;background:[bg3] url([webThemeDir]subscribeform/envelope-bg.png);position:relative;",
    "%wrapper%_wrapper %_container h1": "padding:0;margin:0 0 10px;[tfnt]      color:[titleColor];",
    "%wrapper%_wrapper %_container ul": "margin:0;padding:0;position:relative;",
    "%wrapper%_wrapper %_container ul li": "list-style:none;margin-top:10px;margin-right:10px;",
    "%wrapper%_wrapper %_container ul li:first-child": "margin-top:20px;",
    "%wrapper%_wrapper %_container ul li > span": "display:inline-block;margin:0 10px 0 0;width:100%;",
    "%wrapper%_wrapper %_container ul li%_table-view": "margin:0;",
    "%wrapper%_wrapper %_container ul li%_table-view div": "display:table;width:100%;",
    "%wrapper%_wrapper %_container ul li%_table-view span": "display:table-cell;",
    "%wrapper%_wrapper %_container ul li%_table-view span:last-child": "padding-right:10px;",
    "%wrapper%_wrapper %_container ul li%_table-view span input": "margin-top:10px;",
    "%wrapper%_wrapper %_container div%_error": "[efnt]      color:[txtError];padding-top:5px;",
    "%wrapper input": "margin:0;box-sizing:border-box;color:[txt1];background-color:[bg1];[fnt]  border:[brw] solid [brd];padding:7px;width:100%;",
    "%wrapper input::-webkit-input-placeholder": "color:[labelTxt];",
    "%wrapper input::-ms-input-placeholder": "color:[labelTxt];",
    "%wrapper input::placeholder": "color:[labelTxt];",
    "%wrapper input%_error": "border:[maxbrw] solid [txtError];color:[txtError];box-sizing:border-box;",
    "%wrapper em": "display:block;margin:0 0 10px 15px;font-size:10px;color:[txt1];",
    "%wrapper %_button": "position:relative;display:block;",
    "%wrapper %_button:before": "position:absolute;content:\"\";display:block;left:15px;height:35px;top:-45px;right:0;background:transparent url([webThemeDir]subscribeform/mark.svg) repeat-x;",
    "%wrapper %_button button": "border:0;display:block;margin:0 0 0 15px;box-sizing:border-box;color:[txt2];[fnt2]    padding:calc(7px + [brw]) 24px;max-width:250px;overflow:hidden;background-color:[bg2];white-space:nowrap;",
    "%wrapper %_button button:active,%wrapper %_button button:hover": "color:[txt3];background-color:[bg4];",
    "%wrapper %_phoneField": "position:relative;",
    "%wrapper %_phoneField %_drop-list": "background-color:[bg1];display:inline-block;width:106px;position:relative;padding:0;vertical-align:top;overflow:hidden;white-space:nowrap;border:[brw] solid [brd];box-sizing:border-box;",
    "%wrapper %_phoneField %_drop-list %_selected": "background-color:transparent;display:block;color:[txt1];overflow:hidden;width:100%;margin:0;[fnt]      text-align:center;border:0;padding-right:20px;",
    "%wrapper %_phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;background-image:none;border:0;opacity:0;",
    "%wrapper %_phoneField %_drop-list %_after": "position:absolute;top:5px;right:5px;bottom:5px;text-align:center;padding:5px;width:14px;background:[bg3] no-repeat center;[fnt]",
    "%wrapper %_phoneField %_drop-list %_after svg": "position:absolute;top:50%;margin-top:-4px;left:50%;margin-left:-8px;",
    "%wrapper %_phoneField %_drop-list %_after polygon": "fill:[bg1];",
    "%wrapper %_phoneField %_forPhone": "position:absolute;display:block;left:116px;right:0;top:0;",
    "%wrapper %_message": "margin:15px 0 0;background-color:#26e089;text-align:center;[efnt]  padding:10px 0;display:none;",
    "%wrapper %_message%_success": "background-color:transparent;color:[txtSuccess];display:block;",
    "%wrapper %_message%_error": "background-color:transparent;color:[txtError];display:block;",
    "%wrapper %_message%_editorView": "border:1px dashed #d1d1d1;background-color:#eee;color:#d1d1d1;display:block;",
    "%wrapper %_table": "display:table;width:100%;",
    "%wrapper %_table-row": "display:table-row;width:100%;",
    "%wrapper %_table-cell": "display:table-cell;width:100%;vertical-align:bottom;",
    "%[data-state~=\"right\"]": "direction:rtl;text-align:right;",
    "%[data-state~=\"right\"] %wrapper %_container em": "margin:0 15px 10px 0;",
    "%[data-state~=\"right\"] %wrapper %_container %_button:before": "left:0;right:15px;",
    "%[data-state~=\"right\"] %wrapper %_container %_button button": "margin-right:15px;margin-left:0;",
    "%[data-state~=\"right\"] %wrapper %_container li > span": "margin:0 0 0 10px;",
    "%[data-state~=\"right\"] %wrapper %_container ul li": "margin-left:10px;margin-right:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view": "margin:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view span": "padding-left:10px;padding-right:0;",
    "%[data-state~=\"right\"] %wrapper %_container %phoneField": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %wrapper %_container %phoneField %_forPhone input": "text-align:right;",
    "%[data-state~=\"left\"]": "direction:ltr;text-align:left;",
    "%[data-state~=\"left\"] %wrapper %_container ul li%_table-view span:first-child": "padding-right:10px;",
    "%[data-state~=\"left\"] %wrapper %_container ul li%_table-view span:last-child": "padding-right:10px;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] %wrapper %_table": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_table-row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_table-cell": "display:block;width:100%;vertical-align:bottom;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li%_table-view span": "display:block;padding-right:0;padding-left:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li%_table-view span input": "margin-bottom:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li": "margin-left:0;margin-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_button button": "margin-right:0;margin-left:0;",
    "%[data-state~=\"mobile\"] %wrapper input": "font-size:14px;padding:0 5px;margin:0 0 5px;height:45px;line-height:normal;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper %_phoneField %_drop-list": "height:45px;margin-top:0;line-height:45px;width:86px;",
    "%[data-state~=\"mobile\"] %wrapper %_phoneField %_drop-list %_selected": "height:45px;line-height:35px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper %_phoneField %_forPhone": "left:96px;",
    "%[data-state~=\"mobile\"] %wrapper select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper em": "font-size:10px;margin:10px 0;",
    "%[data-state~=\"mobile\"] %wrapper em + %_button:before": "position:initial;margin-bottom:10px;",
    "%[data-state~=\"mobile\"] %wrapper div%_button": "margin-top:5px;",
    "%[data-state~=\"mobile\"] %wrapper div%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper div%_button button": "margin-left:0;margin-right:0;max-width:auto;min-width:auto;width:100%;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutFlat'] = {
  "react": [
    [
      "div",
      "wrapper",
      [
        "_wrapper"
      ],
      {},
      [
        "div",
        null,
        [
          "_container"
        ],
        {},
        [
          "h1",
          "formTitle",
          [],
          {}
        ],
        [
          "div",
          null,
          [
            "_table"
          ],
          {},
          [
            "div",
            null,
            [
              "_table-row"
            ],
            {},
            [
              "ul",
              null,
              [
                "_table-cell"
              ],
              {},
              [
                "li",
                null,
                [
                  "_table-view"
                ],
                {},
                [
                  "div",
                  null,
                  [],
                  {},
                  [
                    "label",
                    "firstNameFieldLabel",
                    [
                      "_hidden"
                    ],
                    {}
                  ],
                  [
                    "span",
                    "firstNameRow",
                    [
                      "_row"
                    ],
                    {},
                    [
                      "input",
                      "firstNameField",
                      [],
                      {
                        "type": "email",
                        "placeholder": "First name",
                        "name": "first"
                      }
                    ]
                  ],
                  [
                    "label",
                    "lastNameFieldLabel",
                    [
                      "_hidden"
                    ],
                    {}
                  ],
                  [
                    "span",
                    "lastNameRow",
                    [
                      "_row"
                    ],
                    {},
                    [
                      "input",
                      "lastNameField",
                      [],
                      {
                        "type": "email",
                        "placeholder": "Last name",
                        "name": "last"
                      }
                    ]
                  ]
                ]
              ],
              [
                "label",
                "phoneFieldLabel",
                [
                  "_hidden"
                ],
                {}
              ],
              [
                "li",
                "phoneRow",
                [
                  "_row"
                ],
                {},
                [
                  "div",
                  "phoneField",
                  [
                    "_phoneField"
                  ],
                  {},
                  [
                    "span",
                    null,
                    [
                      "_drop-list"
                    ],
                    {},
                    [
                      "input",
                      "selected",
                      [
                        "_selected"
                      ],
                      {
                        "type": "text",
                        "name": "code",
                        "data-skip-placeholder": true
                      }
                    ],
                    [
                      "span",
                      null,
                      [
                        "_after"
                      ],
                      {},
                      [
                        "svg",
                        null,
                        [],
                        {
                          "version": "1.1",
                          "xmlns": "http://www.w3.org/2000/svg",
                          "width": "15px",
                          "height": "7.634px",
                          "viewBox": "0 0 12.854 7.634"
                        },
                        [
                          "polygon",
                          null,
                          [],
                          {
                            "fill": "#FFFFFF",
                            "points": "11.658,0 6.427,5.231 1.197,0 0,1.197 5.231,6.427 5.221,6.437 6.417,7.634 6.427,7.624 7.624,6.427 12.854,1.197 "
                          }
                        ]
                      ]
                    ],
                    [
                      "select",
                      "countryCodesField",
                      [],
                      {
                        "data-skip-placeholder": true
                      }
                    ]
                  ],
                  [
                    "div",
                    null,
                    [
                      "_forPhone"
                    ],
                    {},
                    [
                      "input",
                      "phoneNumberField",
                      [],
                      {
                        "type": "phone",
                        "name": "phone",
                        "placeholder": "Phone number"
                      }
                    ]
                  ]
                ]
              ],
              [
                "label",
                "emailFieldLabel",
                [
                  "_hidden"
                ],
                {}
              ],
              [
                "li",
                "emailRow",
                [
                  "_row"
                ],
                {},
                [
                  "span",
                  null,
                  [],
                  {},
                  [
                    "input",
                    "emailField",
                    [],
                    {
                      "name": "email",
                      "type": "email",
                      "placeholder": "enter your e-mail address"
                    }
                  ]
                ]
              ]
            ],
            [
              "div",
              null,
              [
                "_table-cell"
              ],
              {},
              [
                "div",
                null,
                [
                  "_button"
                ],
                {},
                [
                  "button",
                  "submit",
                  [],
                  {}
                ]
              ]
            ]
          ]
        ],
        [
          "div",
          "notifications",
          [],
          {}
        ]
      ],
      [
        "div",
        "message",
        [
          "_message"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": false,
    "successMessageOutside": true
  },
  "params": {
    "bg3": "BG_COLOR_ALPHA",
    "shd": "BOX_SHADOW",
    "tfnt": "FONT",
    "titleColor": "TEXT_COLOR",
    "txt1": "TEXT_COLOR",
    "bg1": "BG_COLOR_ALPHA",
    "fnt": "FONT",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "txtError": "BORDER_COLOR",
    "labelTxt": "TEXT_COLOR",
    "txt2": "TEXT_COLOR",
    "fnt2": "FONT",
    "bg2": "BG_COLOR_ALPHA",
    "txt3": "TEXT_COLOR",
    "bg4": "BG_COLOR_ALPHA",
    "efnt": "FONT",
    "txtSuccess": "TEXT_COLOR",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "bg3": "color_12",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "tfnt": "font_6",
    "titleColor": "color_15",
    "txt1": "color_15",
    "bg1": "color_11",
    "fnt": "font_9",
    "brw": "1px",
    "brd": "color_12",
    "txtError": "#8b0000",
    "labelTxt": "color_12",
    "txt2": "color_11",
    "fnt2": "font_9",
    "bg2": "color_19",
    "txt3": "color_15",
    "bg4": "color_18",
    "efnt": "font_9",
    "txtSuccess": "#bada55",
    "maxbrw": [
      "brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:505px;min-height:98px;max-width:980px;max-height:1024px;",
    "%wrapper%_wrapper": "width:100%;",
    "%wrapper%_wrapper %_container": "background-color:[bg3];padding:30px 24px;[shd]",
    "%wrapper%_wrapper %_container h1": "padding:0;margin:0 0 10px;[tfnt]      color:[titleColor];",
    "%wrapper%_wrapper %_container ul": "margin:0;padding:0;position:relative;",
    "%wrapper%_wrapper %_container ul li": "list-style:none;margin-top:10px;margin-right:10px;",
    "%wrapper%_wrapper %_container ul li:first-child": "margin-top:20px;",
    "%wrapper%_wrapper %_container ul li > span": "display:inline-block;margin:0 10px 0 0;width:100%;",
    "%wrapper%_wrapper %_container input": "margin:0;box-sizing:border-box;color:[txt1];background-color:[bg1];[fnt]      border:[brw] solid [brd];padding:7px;width:100%;line-height:normal;",
    "%wrapper%_wrapper %_container input%_error": "border:[maxbrw] solid [txtError];color:[txtError];",
    "%wrapper%_wrapper %_container input::-webkit-input-placeholder": "color:[labelTxt];",
    "%wrapper%_wrapper %_container input::-ms-input-placeholder": "color:[labelTxt];",
    "%wrapper%_wrapper %_container input::placeholder": "color:[labelTxt];",
    "%wrapper%_wrapper %_container %_button": "display:block;",
    "%wrapper%_wrapper %_container %_button button": "border:0;display:block;margin:0 0 0 15px;box-sizing:border-box;color:[txt2];[fnt2]        padding:calc(7px + [brw]) calc(24px + [brw]);max-width:250px;overflow:hidden;background-color:[bg2];white-space:nowrap;line-height:normal;",
    "%wrapper%_wrapper %_container %_button button:active,%wrapper%_wrapper %_container %_button button:hover": "color:[txt3];background-color:[bg4];",
    "%wrapper%_wrapper %_container %_phoneField": "position:relative;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list": "background-color:[bg1];border:[brw] solid [brd];display:inline-block;width:106px;position:relative;padding:0;vertical-align:top;overflow:hidden;white-space:nowrap;box-sizing:border-box;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_selected": "background:transparent;display:block;color:[txt1];overflow:hidden;width:100%;margin:0;[fnt]          text-align:center;border:0;padding:6px 20px 6px 7px;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_after": "position:absolute;top:5px;right:5px;bottom:5px;text-align:center;padding:5px;width:14px;background:[bg3] no-repeat center;[fnt]",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_after svg": "position:absolute;top:50%;margin-top:-4px;left:50%;margin-left:-8px;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_after polygon": "fill:[bg1];",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;left:0;right:0;background-image:none;border:0;opacity:0;",
    "%wrapper%_wrapper %_container %_phoneField %_forPhone": "position:absolute;display:block;left:116px;right:0;top:0;",
    "%wrapper%_wrapper %_container ul li%_table-view": "margin:0;",
    "%wrapper%_wrapper %_container ul li%_table-view div": "display:table;width:100%;",
    "%wrapper%_wrapper %_container ul li%_table-view span": "display:table-cell;padding:0 5px;",
    "%wrapper%_wrapper %_container ul li%_table-view span input": "margin-top:10px;",
    "%wrapper%_wrapper %_container div%_error": "[efnt]      color:[txtError];padding-top:5px;",
    "%wrapper%_wrapper %_container %_table": "display:table;width:100%;",
    "%wrapper%_wrapper %_container %_table-row": "display:table-row;width:100%;",
    "%wrapper%_wrapper %_container %_table-cell": "display:table-cell;width:100%;vertical-align:bottom;",
    "%wrapper%_wrapper %_message": "margin:15px 0 0;background-color:#26e089;text-align:center;[efnt]    padding:10px 0;display:none;",
    "%wrapper%_wrapper %_message%_success": "background-color:transparent;color:[txtSuccess];display:block;",
    "%wrapper%_wrapper %_message%_error": "background-color:transparent;color:[txtError];display:block;",
    "%wrapper%_wrapper %_message%_editorView": "border:1px dashed #d1d1d1;background-color:#eee;color:#d1d1d1;display:block;",
    "%[data-state~=\"left\"]": "direction:ltr;text-align:left;",
    "%[data-state~=\"left\"] %wrapper %_container ul li%_table-view span:first-of-type": "padding-left:0;",
    "%[data-state~=\"left\"] %wrapper %_container ul li%_table-view span:last-of-type": "padding-right:10px;",
    "%[data-state~=\"right\"]": "direction:rtl;text-align:right;",
    "%[data-state~=\"right\"] %wrapper %_container ul li": "margin-left:10px;margin-right:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view": "margin:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view span:first-of-type": "padding-right:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view span:last-of-type": "padding-left:10px;",
    "%[data-state~=\"right\"] %wrapper %_container ul li > span": "margin:0 0 0 10px;",
    "%[data-state~=\"right\"] %wrapper %_container %phoneField": "text-align:left;",
    "%[data-state~=\"right\"] %wrapper %_container %_button button": "margin-right:15px;margin-left:0;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_table": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_table-row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_table-cell": "display:block;width:100%;vertical-align:bottom;padding-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li": "margin-left:0;margin-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li%_table-view span": "display:block;padding-right:0 !important;padding-left:0 !important;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li%_table-view span input": "margin-bottom:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container input": "font-size:14px;padding:0 5px;margin:0 0 5px;height:45px;line-height:normal;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_drop-list": "height:45px;margin-top:0;line-height:45px;width:86px;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_drop-list %_selected": "height:45px;line-height:35px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_forPhone": "left:96px;",
    "%[data-state~=\"mobile\"] %wrapper %_container select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper %_container div%_button": "margin-top:5px;",
    "%[data-state~=\"mobile\"] %wrapper %_container div%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_container div%_button button": "margin-left:0;margin-right:0;max-width:auto;min-width:auto;width:100%;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutShiny'] = {
  "react": [
    [
      "div",
      "wrapper",
      [
        "_wrapper"
      ],
      {},
      [
        "label",
        "firstNameFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "label",
        "lastNameFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "label",
        "phoneFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "label",
        "emailFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "div",
        null,
        [
          "_container"
        ],
        {},
        [
          "h1",
          "formTitle",
          [],
          {}
        ],
        [
          "div",
          null,
          [
            "_table"
          ],
          {},
          [
            "div",
            null,
            [
              "_table-row"
            ],
            {},
            [
              "ul",
              null,
              [
                "_table-cell"
              ],
              {},
              [
                "li",
                null,
                [
                  "_table-view"
                ],
                {},
                [
                  "div",
                  null,
                  [],
                  {},
                  [
                    "span",
                    "firstNameRow",
                    [
                      "_row"
                    ],
                    {},
                    [
                      "input",
                      "firstNameField",
                      [],
                      {
                        "type": "text",
                        "placeholder": "First name",
                        "name": "first"
                      }
                    ]
                  ],
                  [
                    "span",
                    "lastNameRow",
                    [
                      "_row"
                    ],
                    {},
                    [
                      "input",
                      "lastNameField",
                      [],
                      {
                        "type": "text",
                        "placeholder": "Last name",
                        "name": "last"
                      }
                    ]
                  ]
                ]
              ],
              [
                "li",
                "phoneRow",
                [
                  "_row"
                ],
                {},
                [
                  "div",
                  "phoneField",
                  [
                    "_phoneField"
                  ],
                  {},
                  [
                    "span",
                    null,
                    [
                      "_drop-list"
                    ],
                    {},
                    [
                      "input",
                      "selected",
                      [
                        "_selected"
                      ],
                      {
                        "type": "text",
                        "name": "code",
                        "data-skip-placeholder": true
                      }
                    ],
                    [
                      "span",
                      null,
                      [
                        "_after"
                      ],
                      {},
                      [
                        "svg",
                        null,
                        [],
                        {
                          "version": "1.1",
                          "xmlns": "http://www.w3.org/2000/svg",
                          "width": "15px",
                          "height": "7.634px",
                          "viewBox": "0 0 12.854 7.634"
                        },
                        [
                          "polygon",
                          null,
                          [],
                          {
                            "fill": "#FFFFFF",
                            "points": "11.658,0 6.427,5.231 1.197,0 0,1.197 5.231,6.427 5.221,6.437 6.417,7.634 6.427,7.624 7.624,6.427 12.854,1.197 "
                          }
                        ]
                      ]
                    ],
                    [
                      "select",
                      "countryCodesField",
                      [],
                      {
                        "data-skip-placeholder": true
                      }
                    ]
                  ],
                  [
                    "div",
                    null,
                    [
                      "_forPhone"
                    ],
                    {},
                    [
                      "input",
                      "phoneNumberField",
                      [],
                      {
                        "type": "phone",
                        "name": "phone",
                        "placeholder": "Phone number"
                      }
                    ]
                  ]
                ]
              ],
              [
                "li",
                "emailRow",
                [
                  "_row"
                ],
                {},
                [
                  "input",
                  "emailField",
                  [
                    "_email"
                  ],
                  {
                    "name": "email",
                    "type": "email",
                    "placeholder": "enter your e-mail address"
                  }
                ]
              ]
            ],
            [
              "div",
              null,
              [
                "_table-cell"
              ],
              {},
              [
                "div",
                null,
                [
                  "_button"
                ],
                {},
                [
                  "a",
                  "submit",
                  [
                    "_submit"
                  ],
                  {}
                ]
              ]
            ]
          ]
        ],
        [
          "div",
          "notifications",
          [],
          {}
        ]
      ],
      [
        "div",
        "message",
        [
          "_message"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": false,
    "successMessageOutside": true
  },
  "params": {
    "bls_bg3": "BG_COLOR_ALPHA",
    "webThemeDir": "URL",
    "bls_shd": "BOX_SHADOW",
    "bls_tfnt": "FONT",
    "bls_titleColor": "TEXT_COLOR",
    "bls_shd_input": "BOX_SHADOW",
    "bls_txt1": "TEXT_COLOR",
    "bls_bg1": "BG_COLOR_ALPHA",
    "bls_fnt": "FONT",
    "bls_brw": "BORDER_SIZE",
    "bls_brd": "BORDER_COLOR_ALPHA",
    "bls_txtError": "BORDER_COLOR",
    "bls_labelTxt": "TEXT_COLOR",
    "bls_shd_subscribe_button": "BOX_SHADOW",
    "bls_txt2": "TEXT_COLOR",
    "bls_fnt2": "FONT",
    "bls_bg2": "BG_COLOR_ALPHA",
    "bls_txt3": "TEXT_COLOR",
    "bls_bg4": "BG_COLOR_ALPHA",
    "bls_efnt": "FONT",
    "bls_txtSuccess": "TEXT_COLOR",
    "bls_shd_input_rtl": "BOX_SHADOW",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "bls_bg3": "color_12",
    "webThemeDir": "WEB_THEME_DIRECTORY",
    "bls_shd": "0 2px 1px 0 rgba(50, 50, 50, 0.2)",
    "bls_tfnt": "font_6",
    "bls_titleColor": "color_15",
    "bls_shd_input": "inset 1px 1px 0 1px rgba(50, 50, 50, 0.2)",
    "bls_txt1": "color_15",
    "bls_bg1": "color_11",
    "bls_fnt": "font_9",
    "bls_brw": "1px",
    "bls_brd": "color_12",
    "bls_txtError": "#8b0000",
    "bls_labelTxt": "color_12",
    "bls_shd_subscribe_button": "inset 0 -15px 5px 0 rgba(50, 50, 50, 0.4)",
    "bls_txt2": "color_11",
    "bls_fnt2": "font_9",
    "bls_bg2": "color_19",
    "bls_txt3": "color_15",
    "bls_bg4": "color_18",
    "bls_efnt": "font_9",
    "bls_txtSuccess": "#bada55",
    "bls_shd_input_rtl": "inset -1px 1px 1px 0 rgba(50, 50, 50, 0.75)",
    "maxbrw": [
      "bls_brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "bls_brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:505px;min-height:98px;max-width:980px;max-heigth:1024px;",
    "%wrapper%_wrapper": "width:100%;",
    "%wrapper%_wrapper %_container": "background:[bls_bg3] url([webThemeDir]subscribeform/shiny_bg.png) repeat-x 50% 0%;padding:30px 24px;[bls_shd]",
    "%wrapper%_wrapper %_container h1": "padding:0;margin:0 0 10px;[bls_tfnt]      color:[bls_titleColor];",
    "%wrapper%_wrapper %_container ul": "margin:0;padding:0;position:relative;",
    "%wrapper%_wrapper %_container ul li": "list-style:none;margin-top:10px;margin-right:10px;",
    "%wrapper%_wrapper %_container ul li:first-child": "margin-top:20px;",
    "%wrapper%_wrapper %_container ul li%_email-container": "margin-right:0;",
    "%wrapper%_wrapper %_container ul li%_table-view": "margin:0;",
    "%wrapper%_wrapper %_container ul li%_table-view div": "display:table;width:100%;",
    "%wrapper%_wrapper %_container ul li%_table-view span": "display:table-cell;padding-right:10px;",
    "%wrapper%_wrapper %_container ul li%_table-view span input": "margin-top:10px;",
    "%wrapper%_wrapper %_container ul li%_table-view > span": "display:inline-block;margin:0 10px 0 0;width:100%;[bls_shd_input]          z-index:1;position:relative;",
    "%wrapper%_wrapper %_container input": "margin:0;color:[bls_txt1];background-color:[bls_bg1];[bls_fnt]      [bls_shd_input]      border:[bls_brw] solid [bls_brd];padding:7px;width:100%;display:block;line-height:normal;",
    "%wrapper%_wrapper %_container input%_error": "border:[maxbrw] solid [bls_txtError];color:[bls_txtError];box-sizing:border-box;",
    "%wrapper%_wrapper %_container input::-webkit-input-placeholder": "color:[bls_labelTxt];",
    "%wrapper%_wrapper %_container input::-ms-input-placeholder": "color:[bls_labelTxt];",
    "%wrapper%_wrapper %_container input::placeholder": "color:[bls_labelTxt];",
    "%wrapper%_wrapper %_container %_button": "display:block;position:relative;",
    "%wrapper%_wrapper %_container %_button a%_submit": "[bls_shd_subscribe_button]        display:block;color:[bls_txt2];[bls_fnt2]        padding:calc([bls_brw] + 7px) 24px;max-width:250px;overflow:hidden;background-color:[bls_bg2];white-space:nowrap;line-height:normal;margin-left:14px;margin-right:calc(1px + [bls_brw]);",
    "%wrapper%_wrapper %_container %_button a%_submit:active,%wrapper%_wrapper %_container %_button a%_submit:hover": "color:[bls_txt3];background-color:[bls_bg4];",
    "%wrapper%_wrapper %_container %_phoneField": "position:relative;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list": "background-color:[bls_bg1];display:inline-block;width:106px;position:relative;padding:0;vertical-align:top;overflow:hidden;white-space:nowrap;border:[bls_brw] solid [bls_brd];box-sizing:border-box;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_selected": "background-color:transparent;display:block;color:[bls_txt1];overflow:hidden;width:100%;margin:0;[bls_fnt]          text-align:center;border:0;padding:6px 20px 6px 0;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_after": "position:absolute;top:5px;right:5px;bottom:5px;text-align:center;padding:5px;width:14px;background:[bls_bg3] no-repeat center;[bls_fnt]",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_after svg": "position:absolute;top:50%;margin-top:-4px;left:50%;margin-left:-8px;",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list %_after polygon": "fill:[bls_bg1];",
    "%wrapper%_wrapper %_container %_phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;left:0;right:0;background-image:none;border:0;opacity:0;",
    "%wrapper%_wrapper %_container %_phoneField %_forPhone": "position:absolute;display:block;left:116px;right:0;top:0;",
    "%wrapper%_wrapper %_container div%_error": "[bls_efnt]      color:[bls_txtError];padding-top:5px;",
    "%wrapper%_wrapper %_container %_table-row": "display:table-row;width:100%;",
    "%wrapper%_wrapper %_container %_table": "display:table;width:100%;position:relative;",
    "%wrapper%_wrapper %_container %_email-wrapper": "position:absolute;left:0;right:0;bottom:0;display:block;[bls_fnt]      [bls_shd_input]      border:[bls_brw] solid transparent;background-color:[bls_bg1];padding:6px;",
    "%wrapper%_wrapper %_container %_table-cell": "display:table-cell;width:100%;vertical-align:bottom;",
    "%wrapper%_wrapper %_message": "margin:15px 0 0;background-color:#26e089;text-align:center;[bls_efnt]    padding:10px 0;display:none;",
    "%wrapper%_wrapper %_message%_success": "background-color:transparent;color:[bls_txtSuccess];display:block;",
    "%wrapper%_wrapper %_message%_error": "background-color:transparent;color:[bls_txtError];display:block;",
    "%wrapper%_wrapper %_message%_editorView": "border:1px dashed #d1d1d1;background-color:#eee;color:#d1d1d1;display:block;",
    "%[data-state~=\"left\"]": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"]": "direction:rtl;text-align:right;",
    "%[data-state~=\"right\"] %wrapper %_container ul li": "margin-left:10px;margin-right:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li > span": "margin:0 0 0 10px;[bls_shd_input_rtl]",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view": "margin:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view span": "padding-left:10px;padding-right:0;",
    "%[data-state~=\"right\"] %wrapper %_container ul li%_table-view%_email-container": "margin-left:0;",
    "%[data-state~=\"right\"] %wrapper %_container input": "[bls_shd_input_rtl]",
    "%[data-state~=\"right\"] %wrapper %_container %_button": "position:relative;",
    "%[data-state~=\"right\"] %wrapper %_container %_button a%_submit": "margin-right:15px;margin-left:0;",
    "%[data-state~=\"right\"] %wrapper %_container %phoneField": "text-align:left;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_table": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_table-row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_table-cell": "display:block;width:100%;vertical-align:bottom;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li": "margin-left:0;margin-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li%_table-view span": "display:block;padding-right:0;padding-left:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container ul li%_table-view span input": "margin-bottom:0;",
    "%[data-state~=\"mobile\"] %wrapper %_container input": "font-size:14px;padding:0 5px;margin:0 0 5px 0;height:45px;line-height:normal;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_drop-list": "height:45px;margin-top:0;line-height:45px;width:86px;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_drop-list %_selected": "height:45px;line-height:35px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_drop-list select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper %_container %_phoneField %_forPhone": "left:96px;",
    "%[data-state~=\"mobile\"] %wrapper %_container div%_button": "margin-top:5px;",
    "%[data-state~=\"mobile\"] %wrapper %_container div%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_container div%_button a%_submit": "margin-left:0;margin-right:0;max-width:auto;min-width:auto;margin-top:10px;text-align:center;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutFlat'] = {
  "react": [
    [
      "div",
      "wrapper",
      [
        "_wrapper"
      ],
      {},
      [
        "div",
        null,
        [
          "_container"
        ],
        {},
        [
          "div",
          null,
          [
            "_table",
            "_invertible"
          ],
          {},
          [
            "div",
            null,
            [
              "_table-row"
            ],
            {},
            [
              "div",
              null,
              [
                "_table-cell",
                "_table-cell-container"
              ],
              {},
              [
                "div",
                null,
                [
                  "_table",
                  "_fixed"
                ],
                {},
                [
                  "div",
                  null,
                  [
                    "_table-row"
                  ],
                  {},
                  [
                    "h1",
                    "formTitle",
                    [
                      "_table-cell",
                      "_title"
                    ],
                    {}
                  ],
                  [
                    "label",
                    "emailFieldLabel",
                    [
                      "_hidden"
                    ],
                    {}
                  ],
                  [
                    "div",
                    null,
                    [
                      "_table-cell"
                    ],
                    {},
                    [
                      "input",
                      "emailField",
                      [
                        "_input"
                      ],
                      {
                        "placeholder": "enter your e-mail address",
                        "name": "email",
                        "type": "text"
                      }
                    ]
                  ]
                ]
              ],
              [
                "div",
                null,
                [
                  "_line"
                ],
                {},
                [
                  "div",
                  "phoneRow",
                  [
                    "_line-item",
                    "_phone",
                    "_row"
                  ],
                  {},
                  [
                    "div",
                    null,
                    [
                      "_phone_wrapper"
                    ],
                    {},
                    [
                      "label",
                      "phoneFieldLabel",
                      [
                        "_hidden"
                      ],
                      {}
                    ],
                    [
                      "div",
                      "phoneField",
                      [
                        "_phoneField"
                      ],
                      {},
                      [
                        "span",
                        null,
                        [
                          "_drop-list"
                        ],
                        {},
                        [
                          "input",
                          "selected",
                          [
                            "_input",
                            "_selected"
                          ],
                          {
                            "type": "text",
                            "name": "code",
                            "data-skip-placeholder": true,
                            "disabled": true
                          }
                        ],
                        [
                          "span",
                          null,
                          [
                            "_after"
                          ],
                          {},
                          [
                            "svg",
                            null,
                            [],
                            {
                              "version": "1.1",
                              "xmlns": "http://www.w3.org/2000/svg",
                              "width": "15px",
                              "height": "7.634px",
                              "viewBox": "0 0 12.854 7.634"
                            },
                            [
                              "polygon",
                              null,
                              [],
                              {
                                "fill": "#FFFFFF",
                                "points": "11.658,0 6.427,5.231 1.197,0 0,1.197 5.231,6.427 5.221,6.437 6.417,7.634 6.427,7.624 7.624,6.427 12.854,1.197 "
                              }
                            ]
                          ]
                        ],
                        [
                          "select",
                          "countryCodesField",
                          [],
                          {
                            "data-skip-placeholder": true
                          }
                        ]
                      ],
                      [
                        "div",
                        null,
                        [
                          "_forPhone"
                        ],
                        {},
                        [
                          "input",
                          "phoneNumberField",
                          [
                            "_input"
                          ],
                          {
                            "type": "phone",
                            "name": "phone",
                            "placeholder": "Phone number"
                          }
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "div",
                  null,
                  [
                    "_line-item",
                    "_table",
                    "_fixed"
                  ],
                  {},
                  [
                    "div",
                    null,
                    [
                      "_table-row"
                    ],
                    {},
                    [
                      "div",
                      null,
                      [
                        "_table-cell",
                        "_with-inner-table"
                      ],
                      {},
                      [
                        "div",
                        null,
                        [
                          "_table",
                          "_fixed"
                        ],
                        {},
                        [
                          "div",
                          null,
                          [
                            "_table-row"
                          ],
                          {},
                          [
                            "label",
                            "firstNameFieldLabel",
                            [
                              "_hidden"
                            ],
                            {}
                          ],
                          [
                            "div",
                            "firstNameRow",
                            [
                              "_table-cell",
                              "_row"
                            ],
                            {},
                            [
                              "input",
                              "firstNameField",
                              [
                                "_input"
                              ],
                              {
                                "placeholder": "First Name",
                                "name": "first",
                                "type": "text"
                              }
                            ]
                          ],
                          [
                            "label",
                            "lastNameFieldLabel",
                            [
                              "_hidden"
                            ],
                            {}
                          ],
                          [
                            "div",
                            "lastNameRow",
                            [
                              "_table-cell",
                              "_row"
                            ],
                            {},
                            [
                              "input",
                              "lastNameField",
                              [
                                "_input"
                              ],
                              {
                                "placeholder": "Last Name",
                                "name": "last",
                                "type": "text"
                              }
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            [
              "div",
              null,
              [
                "_table-cell",
                "_table-cell-button-container"
              ],
              {},
              [
                "div",
                null,
                [
                  "_button"
                ],
                {},
                [
                  "a",
                  "submit",
                  [],
                  {}
                ]
              ]
            ]
          ]
        ],
        [
          "div",
          "notifications",
          [],
          {}
        ]
      ],
      [
        "div",
        "message",
        [
          "_message"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": false,
    "successMessageOutside": true
  },
  "params": {
    "llf_bg3": "BG_COLOR_ALPHA",
    "llf_shd": "BOX_SHADOW",
    "llf_fnt2": "FONT",
    "llf_txt2": "TEXT_COLOR",
    "llf_brw": "BORDER_SIZE",
    "llf_bg2": "BG_COLOR_ALPHA",
    "llf_txt3": "TEXT_COLOR",
    "llf_bg4": "BG_COLOR_ALPHA",
    "llf_tfnt": "FONT",
    "llf_titleColor": "TEXT_COLOR",
    "llf_txt1": "TEXT_COLOR",
    "llf_bg1": "BG_COLOR_ALPHA",
    "llf_fnt": "FONT",
    "llf_brd": "BORDER_COLOR_ALPHA",
    "llf_labelTxt": "TEXT_COLOR",
    "llf_txtError": "BORDER_COLOR",
    "llf_efnt": "FONT",
    "llf_txtSuccess": "TEXT_COLOR",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "llf_bg3": "color_12",
    "llf_shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "llf_fnt2": "font_9",
    "llf_txt2": "color_11",
    "llf_brw": "1px",
    "llf_bg2": "color_19",
    "llf_txt3": "color_15",
    "llf_bg4": "color_18",
    "llf_tfnt": "font_6",
    "llf_titleColor": "color_15",
    "llf_txt1": "color_15",
    "llf_bg1": "color_11",
    "llf_fnt": "font_9",
    "llf_brd": "color_12",
    "llf_labelTxt": "color_12",
    "llf_txtError": "#8b0000",
    "llf_efnt": "font_9",
    "llf_txtSuccess": "#bada55",
    "maxbrw": [
      "llf_brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "llf_brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:724px;min-height:85px;max-width:1000px;max-height:300px;",
    "%wrapper%_wrapper": "width:100%;",
    "%wrapper%_wrapper %_container": "background-color:[llf_bg3];padding:30px 24px 40px;[llf_shd]",
    "%wrapper%_wrapper %_container %_table-cell%_table-cell-container": "padding-right:14px;padding-top:0;width:100%;",
    "%wrapper%_wrapper %_container %_table": "display:table;width:100%;",
    "%wrapper%_wrapper %_container %_table%_fixed": "table-layout:fixed;",
    "%wrapper%_wrapper %_container %_table-row": "display:table-row;width:100%;",
    "%wrapper%_wrapper %_container %_table-cell": "vertical-align:bottom;display:table-cell;padding-right:10px;padding-top:10px;",
    "%wrapper%_wrapper %_container %_table-cell%_with-inner-table": "padding-right:0;padding-top:0;",
    "%wrapper%_wrapper %_container %_table-cell%_table-cell-button-container": "padding-right:0;",
    "%wrapper%_wrapper %_container %_button": "margin-bottom:1px;",
    "%wrapper%_wrapper %_container %_button a": "[llf_fnt2]        white-space:nowrap;max-width:250px;overflow:hidden;color:[llf_txt2];padding:calc(6px + [llf_brw]) 24px;box-sizing:border-box;display:block;background-color:[llf_bg2];border:none;",
    "%wrapper%_wrapper %_container %_button a:active,%wrapper%_wrapper %_container %_button a:hover": "color:[llf_txt3];background-color:[llf_bg4];",
    "%wrapper%_wrapper %_container %_title": "[llf_tfnt]      color:[llf_titleColor];vertical-align:bottom;",
    "%wrapper%_wrapper %_container %_input": "box-sizing:border-box;color:[llf_txt1];background-color:[llf_bg1];[llf_fnt]      padding:7px;width:100%;border:[llf_brw] solid [llf_brd];margin:0;",
    "%wrapper%_wrapper %_container %_input::-webkit-input-placeholder": "color:[llf_labelTxt];padding-left:15px;",
    "%wrapper%_wrapper %_container %_input::-ms-input-placeholder": "color:[llf_labelTxt];padding-left:15px;",
    "%wrapper%_wrapper %_container %_input::placeholder": "color:[llf_labelTxt];padding-left:15px;",
    "%wrapper%_wrapper %_container %_input%_error": "border:[maxbrw] solid [llf_txtError];color:[llf_txtError];",
    "%wrapper%_wrapper %_container %_line": "overflow:hidden;",
    "%wrapper%_wrapper %_container %_line %_line-item": "float:left;width:50%;",
    "%wrapper%_wrapper %_container %_line %_line-item%_phone": "padding-top:10px;position:relative;",
    "%wrapper%_wrapper %_container %_line %_line-item%_phone %_note": "font-size:13px;position:absolute;color:[llf_txt1];left:0;",
    "%wrapper%_wrapper %_container %_phone_wrapper": "padding-right:10px;direction:initial;",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField": "position:relative;",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_drop-list": "background-color:[llf_bg1];display:inline-block;width:106px;position:relative;padding:0;vertical-align:top;overflow:hidden;white-space:nowrap;border:[llf_brw] solid [llf_brd];box-sizing:border-box;",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_drop-list %_selected": "background-color:transparent;display:block;color:[llf_txt1];overflow:hidden;width:100%;margin:0;[llf_fnt]            text-align:center;border:0;padding-right:20px;",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_drop-list %_after": "position:absolute;top:5px;right:5px;bottom:5px;text-align:center;padding:5px;width:14px;background-color:[llf_bg3];background-repeat:no-repeat;background-position:50% 50%;[llf_fnt]",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_drop-list %_after svg": "position:absolute;top:50%;margin-top:-4px;left:50%;margin-left:-8px;",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_drop-list %_after polygon": "fill:[llf_bg1];",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;background-image:none;border:0;opacity:0;",
    "%wrapper%_wrapper %_container %_phone_wrapper %_phoneField %_forPhone": "position:absolute;display:block;left:116px;right:0;top:0;",
    "%wrapper%_wrapper %_container div%_error": "[llf_efnt]      color:[llf_txtError];padding-top:5px;",
    "%wrapper%_wrapper %_message": "margin:15px 0 0;padding:10px 0;text-align:center;[llf_efnt]    background-color:#26e089;display:none;",
    "%wrapper%_wrapper %_message%_success": "background-color:transparent;color:[llf_txtSuccess];display:block;",
    "%wrapper%_wrapper %_message%_error": "background-color:transparent;color:[llf_txtError];display:block;",
    "%wrapper%_wrapper %_message%_editorView": "border:1px solid #d1d1d1;background-color:#eeeeee;display:block;color:#d1d1d1;",
    "%[data-state~=\"right\"] %wrapper %_table%_invertible": "direction:rtl;",
    "%[data-state~=\"right\"] %wrapper %_table-cell%_table-cell-container": "padding-left:24px;padding-right:0;",
    "%[data-state~=\"right\"] %wrapper %phoneNumberField": "direction:rtl;",
    "%[data-state~=\"right\"] %wrapper %_container %_phone_wrapper %_phoneField %_drop-list": "float:left;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] %wrapper %_table": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_table-row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_table-cell": "display:block;width:100%;vertical-align:bottom;padding-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_input": "font-size:14px;margin:0 0 5px 0;height:45px;line-height:normal;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper": "padding-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_drop-list": "height:45px;margin-top:0;line-height:45px;width:86px;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_drop-list %_selected": "height:45px;line-height:45px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_drop-list select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_forPhone": "left:96px;",
    "%[data-state~=\"mobile\"] %wrapper div%_button": "margin-top:5px;",
    "%[data-state~=\"mobile\"] %wrapper div%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper div%_button a": "margin-left:0;margin-right:0;max-width:initial;min-width:initial;width:100%;text-align:center;",
    "%[data-state~=\"mobile\"] %wrapper %_line": "overflow:hidden;",
    "%[data-state~=\"mobile\"] %wrapper %_line %_line-item": "width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_line %_line-item%_phone": "padding-bottom:5px;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutTransparentWithIcon'] = {
  "react": [
    [
      "div",
      "wrapper",
      [
        "_wrapper"
      ],
      {},
      [
        "div",
        null,
        [
          "_container"
        ],
        {},
        [
          "div",
          null,
          [
            "_table",
            "_invertible"
          ],
          {},
          [
            "div",
            null,
            [
              "_table-row"
            ],
            {},
            [
              "div",
              null,
              [
                "_table-cell",
                "_table-cell-container"
              ],
              {},
              [
                "div",
                null,
                [
                  "_table",
                  "_fixed"
                ],
                {},
                [
                  "div",
                  null,
                  [
                    "_table-row"
                  ],
                  {},
                  [
                    "div",
                    null,
                    [
                      "_table-cell",
                      "_table-cell-title"
                    ],
                    {},
                    [
                      "div",
                      null,
                      [],
                      {},
                      [
                        "i",
                        null,
                        [
                          "_icon-envelope"
                        ],
                        {},
                        [
                          "svg",
                          null,
                          [],
                          {
                            "width": "54",
                            "height": "54",
                            "xmlns": "http://www.w3.org/2000/svg"
                          },
                          [
                            "g",
                            null,
                            [],
                            {},
                            [
                              "rect",
                              "svg_3",
                              [],
                              {
                                "fill": "",
                                "fillOpacity": "0.0",
                                "stroke": "#ffffff",
                                "strokeWidth": "3",
                                "strokeLinejoin": "miter",
                                "strokeLinecap": "butt",
                                "x": "14.75",
                                "y": "20",
                                "width": "24",
                                "height": "16"
                              }
                            ],
                            [
                              "line",
                              "svg_10",
                              [],
                              {
                                "fill": "none",
                                "stroke": "#ffffff",
                                "strokeWidth": "3",
                                "strokeLinejoin": "miter",
                                "strokeLinecap": "butt",
                                "x1": "15.5",
                                "y1": "25.75",
                                "x2": "29.58013",
                                "y2": "25.75",
                                "transform": "rotate(37.00132751464844 22.540069580078132,25.749999999999996)"
                              }
                            ],
                            [
                              "line",
                              "svg_11",
                              [],
                              {
                                "fill": "none",
                                "stroke": "#ffffff",
                                "strokeWidth": "3",
                                "strokeLinejoin": "miter",
                                "strokeLinecap": "butt",
                                "x1": "23.95994",
                                "y1": "25.75",
                                "x2": "38.04007",
                                "y2": "25.75",
                                "transform": "rotate(-36.52885437011719 31,25.750000000000007)"
                              }
                            ]
                          ]
                        ]
                      ]
                    ],
                    [
                      "h1",
                      "formTitle",
                      [
                        "_title",
                        "_with-envelope-icon"
                      ],
                      {}
                    ]
                  ],
                  [
                    "label",
                    "emailFieldLabel",
                    [
                      "_hidden"
                    ],
                    {}
                  ],
                  [
                    "div",
                    null,
                    [
                      "_table-cell"
                    ],
                    {},
                    [
                      "input",
                      "emailField",
                      [
                        "_input"
                      ],
                      {
                        "placeholder": "enter your e-mail address",
                        "name": "email",
                        "type": "email"
                      }
                    ]
                  ]
                ]
              ],
              [
                "div",
                null,
                [
                  "_line"
                ],
                {},
                [
                  "div",
                  "phoneRow",
                  [
                    "_line-item",
                    "_phone",
                    "_row"
                  ],
                  {},
                  [
                    "div",
                    null,
                    [
                      "_phone_wrapper"
                    ],
                    {},
                    [
                      "label",
                      "phoneFieldLabel",
                      [
                        "_hidden"
                      ],
                      {}
                    ],
                    [
                      "div",
                      "phoneField",
                      [
                        "_phoneField"
                      ],
                      {},
                      [
                        "span",
                        null,
                        [
                          "_drop-list"
                        ],
                        {},
                        [
                          "input",
                          "selected",
                          [
                            "_input",
                            "_selected"
                          ],
                          {
                            "type": "text",
                            "name": "code",
                            "data-skip-placeholder": true,
                            "disabled": true
                          }
                        ],
                        [
                          "span",
                          null,
                          [
                            "_after"
                          ],
                          {},
                          [
                            "svg",
                            null,
                            [],
                            {
                              "version": "1.1",
                              "xmlns": "http://www.w3.org/2000/svg",
                              "width": "15px",
                              "height": "7.634px",
                              "viewBox": "0 0 12.854 7.634"
                            },
                            [
                              "polygon",
                              null,
                              [],
                              {
                                "fill": "#FFFFFF",
                                "points": "11.658,0 6.427,5.231 1.197,0 0,1.197 5.231,6.427 5.221,6.437 6.417,7.634 6.427,7.624 7.624,6.427 12.854,1.197 "
                              }
                            ]
                          ]
                        ],
                        [
                          "select",
                          "countryCodesField",
                          [],
                          {
                            "data-skip-placeholder": true
                          }
                        ]
                      ],
                      [
                        "div",
                        null,
                        [
                          "_forPhone"
                        ],
                        {},
                        [
                          "input",
                          "phoneNumberField",
                          [
                            "_input"
                          ],
                          {
                            "type": "phone",
                            "name": "phone",
                            "placeholder": "Phone number"
                          }
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "div",
                  null,
                  [
                    "_line-item",
                    "_table",
                    "_fixed"
                  ],
                  {},
                  [
                    "div",
                    null,
                    [
                      "_table-row"
                    ],
                    {},
                    [
                      "div",
                      null,
                      [
                        "_table-cell",
                        "_with-inner-table"
                      ],
                      {},
                      [
                        "div",
                        null,
                        [
                          "_table",
                          "_fixed"
                        ],
                        {},
                        [
                          "div",
                          null,
                          [
                            "_table-row"
                          ],
                          {},
                          [
                            "label",
                            "firstNameFieldLabel",
                            [
                              "_hidden"
                            ],
                            {}
                          ],
                          [
                            "div",
                            "firstNameRow",
                            [
                              "_table-cell",
                              "_row",
                              "_bottom"
                            ],
                            {},
                            [
                              "input",
                              "firstNameField",
                              [
                                "_input"
                              ],
                              {
                                "name": "first",
                                "placeholder": "First Name",
                                "type": "text"
                              }
                            ]
                          ],
                          [
                            "label",
                            "lastNameFieldLabel",
                            [
                              "_hidden"
                            ],
                            {}
                          ],
                          [
                            "div",
                            "lastNameRow",
                            [
                              "_table-cell",
                              "_row",
                              "_bottom"
                            ],
                            {},
                            [
                              "input",
                              "lastNameField",
                              [
                                "_input"
                              ],
                              {
                                "name": "last",
                                "placeholder": "Last Name",
                                "type": "text"
                              }
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            [
              "div",
              null,
              [
                "_table-cell",
                "_table-cell-button-container"
              ],
              {},
              [
                "div",
                null,
                [
                  "_button"
                ],
                {},
                [
                  "button",
                  "submit",
                  [],
                  {}
                ]
              ]
            ]
          ]
        ],
        [
          "div",
          "notifications",
          [],
          {}
        ]
      ],
      [
        "div",
        "message",
        [
          "_message"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": false,
    "successMessageOutside": true
  },
  "params": {
    "llf_bg3": "BG_COLOR_ALPHA",
    "llf_brd": "BORDER_COLOR_ALPHA",
    "llf_shd": "BOX_SHADOW",
    "llf_fnt2": "FONT",
    "llf_txt2": "TEXT_COLOR",
    "llf_brw": "BORDER_SIZE",
    "llf_bg2": "BG_COLOR_ALPHA",
    "llf_txt3": "TEXT_COLOR",
    "llf_bg4": "BG_COLOR_ALPHA",
    "llf_icon_color": "BG_COLOR_ALPHA",
    "llf_tfnt": "FONT",
    "llf_titleColor": "TEXT_COLOR",
    "llf_txt1": "TEXT_COLOR",
    "llf_bg1": "BG_COLOR_ALPHA",
    "llf_fnt": "FONT",
    "llf_labelTxt": "TEXT_COLOR",
    "llf_txtError": "BORDER_COLOR",
    "llf_efnt": "FONT",
    "llf_txtSuccess": "TEXT_COLOR",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "llf_bg3": "color_11",
    "llf_brd": "color_12",
    "llf_shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "llf_fnt2": "font_9",
    "llf_txt2": "color_11",
    "llf_brw": "1px",
    "llf_bg2": "color_19",
    "llf_txt3": "color_15",
    "llf_bg4": "color_18",
    "llf_icon_color": "color_12",
    "llf_tfnt": "font_6",
    "llf_titleColor": "color_15",
    "llf_txt1": "color_15",
    "llf_bg1": "color_11",
    "llf_fnt": "font_9",
    "llf_labelTxt": "color_12",
    "llf_txtError": "#8b0000",
    "llf_efnt": "font_9",
    "llf_txtSuccess": "#bada55",
    "maxbrw": [
      "llf_brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "llf_brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:800px;min-height:81px;max-width:1000px;max-height:300px;",
    "%wrapper%_wrapper": "width:100%;",
    "%wrapper%_wrapper %_container": "background-color:[llf_bg3];padding:4px 24px 24px;border-top:1px solid [llf_brd];border-bottom:1px solid [llf_brd];[llf_shd]",
    "%wrapper%_wrapper %_container %_table-cell%_table-cell-container": "padding-right:4px;width:100%;",
    "%wrapper%_wrapper %_container %_table": "display:table;width:100%;",
    "%wrapper%_wrapper %_container %_table%_fixed": "table-layout:fixed;",
    "%wrapper%_wrapper %_container %_table-row": "display:table-row;width:100%;",
    "%wrapper%_wrapper %_container %_table-cell": "vertical-align:bottom;display:table-cell;padding-right:20px;padding-top:10px;",
    "%wrapper%_wrapper %_container %_table-cell%_table-cell-title": "position:relative;vertical-align:middle;",
    "%wrapper%_wrapper %_container %_table-cell%_bottom": "padding-top:20px;",
    "%wrapper%_wrapper %_container %_table-cell%_with-inner-table": "padding-right:0;padding-top:0;",
    "%wrapper%_wrapper %_container %_table-cell%_table-cell-button-container": "padding-right:0;",
    "%wrapper%_wrapper %_button button": "[llf_fnt2]    white-space:nowrap;max-width:250px;overflow:hidden;color:[llf_txt2];padding:calc(7px + [llf_brw]) calc(24px + [llf_brw]);margin:0;box-sizing:border-box;display:block;background-color:[llf_bg2];border:0;",
    "%wrapper%_wrapper %_button button:active,%wrapper%_wrapper %_button button:hover": "color:[llf_txt3];background-color:[llf_bg4];",
    "%wrapper%_wrapper %_icon-envelope": "width:54px;height:54px;display:block;float:left;position:absolute;top:0;background-color:[llf_icon_color];border-radius:50%;",
    "%wrapper%_wrapper %_icon-envelope rect": "fill-opacity:0;stroke-width:3;",
    "%wrapper%_wrapper %_icon-envelope line": "stroke-width:3;",
    "%wrapper%_wrapper %_title": "[llf_tfnt]    color:[llf_titleColor];vertical-align:middle;",
    "%wrapper%_wrapper %_with-envelope-icon": "padding-left:65px;",
    "%wrapper%_wrapper %_input": "box-sizing:border-box;color:[llf_txt1];background-color:[llf_bg1];[llf_fnt]    padding:7px;width:100%;border:[llf_brw] solid [llf_brd];margin:0;",
    "%wrapper%_wrapper %_input::-webkit-input-placeholder": "color:[llf_labelTxt];padding-left:15px;",
    "%wrapper%_wrapper %_input::-ms-input-placeholder": "color:[llf_labelTxt];padding-left:15px;",
    "%wrapper%_wrapper %_input::placeholder": "color:[llf_labelTxt];padding-left:15px;",
    "%wrapper%_wrapper %_input%_error": "border:[maxbrw] solid [llf_txtError];color:[llf_txtError];",
    "%wrapper%_wrapper %_line": "overflow:hidden;",
    "%wrapper%_wrapper %_line %_line-item": "float:left;width:50%;",
    "%wrapper%_wrapper %_line %_line-item%_phone": "padding-top:20px;position:relative;",
    "%wrapper%_wrapper %_phone_wrapper": "padding-right:20px;direction:initial;",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField": "position:relative;",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_drop-list": "background-color:[llf_bg1];display:inline-block;width:106px;position:relative;padding:0;vertical-align:top;overflow:hidden;white-space:nowrap;border:[llf_brw] solid [llf_brd];box-sizing:border-box;",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_drop-list %_selected": "background-color:transparent;display:block;color:[llf_txt1];overflow:hidden;width:100%;margin:0;[llf_fnt]          text-align:center;border:0;padding-right:20px;",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_drop-list %_after": "position:absolute;top:5px;right:5px;bottom:5px;text-align:center;padding:5px;width:14px;background:[llf_bg3] no-repeat 50% 50%;[llf_fnt]",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_drop-list %_after svg": "position:absolute;top:50%;margin-top:-4px;left:50%;margin-left:-8px;",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_drop-list %_after polygon": "fill:[llf_bg1];",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;background-image:none;border:0;opacity:0;",
    "%wrapper%_wrapper %_phone_wrapper %_phoneField %_forPhone": "position:absolute;display:block;left:126px;right:0;top:0;",
    "%wrapper%_wrapper %_message": "margin:15px 0 0;padding:10px 0;text-align:center;[llf_efnt]",
    "%wrapper%_wrapper %_message %_editorView": "background-color:[llf_bg3];color:#d1d1d1;",
    "%wrapper%_wrapper %_success": "background-color:transparent;color:[llf_txtSuccess];display:block;",
    "%wrapper%_wrapper %_error": "background-color:transparent;color:[llf_txtError];display:block;",
    "%wrapper%_wrapper div%_error": "[llf_efnt]    color:[llf_txtError];padding-top:5px;",
    "%[data-state~=\"right\"] %wrapper %_table%_invertible": "direction:rtl;",
    "%[data-state~=\"right\"] %wrapper %_table-cell%_table-cell-container": "padding-left:24px;padding-right:0;",
    "%[data-state~=\"right\"] %wrapper %_with-envelope-icon": "padding-right:65px;padding-left:0;",
    "%[data-state~=\"right\"] %wrapper %_container": "padding-right:4px;",
    "%[data-state~=\"right\"] %wrapper %_phone_wrapper %_phoneField %_drop-list": "float:left;",
    "%[data-state~=\"right\"] %wrapper %phoneNumberField": "direction:rtl;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] %wrapper %_icon-envelope": "position:initial;",
    "%[data-state~=\"mobile\"] %wrapper %_table": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_table-row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_table-cell": "display:block;width:100%;vertical-align:bottom;padding-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_input": "font-size:14px;margin:0 0 5px 0;height:45px;line-height:normal;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper": "padding-right:0;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_drop-list": "float:left;height:45px;margin-top:0;line-height:45px;width:86px;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_drop-list %_selected": "height:45px;line-height:45px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_drop-list select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper %_phone_wrapper %_phoneField %_forPhone": "left:96px;",
    "%[data-state~=\"mobile\"] %wrapper div%_button": "margin-top:5px;",
    "%[data-state~=\"mobile\"] %wrapper div%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper div%_button button": "margin-left:0;margin-right:0;max-width:initial;min-width:initial;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_line": "overflow:hidden;",
    "%[data-state~=\"mobile\"] %wrapper %_line %_line-item": "width:100%;",
    "%[data-state~=\"mobile\"] %wrapper %_line %_line-item%_phone": "padding-bottom:5px;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormPlaceholderSkin'] = {
  "react": [
    [
      "div",
      "wrapper",
      [],
      {},
      [
        "div",
        "formTitle",
        [],
        {}
      ],
      [
        "label",
        "firstNameFieldLabel",
        [
          "_cell"
        ],
        {}
      ],
      [
        "div",
        "firstNameRow",
        [
          "_row"
        ],
        {},
        [
          "input",
          "firstNameField",
          [],
          {
            "type": "text",
            "name": "first"
          }
        ]
      ],
      [
        "label",
        "lastNameFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "div",
        "lastNameRow",
        [
          "_row"
        ],
        {},
        [
          "input",
          "lastNameField",
          [],
          {
            "type": "text",
            "name": "last"
          }
        ]
      ],
      [
        "label",
        "emailFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "div",
        "emailRow",
        [
          "_row"
        ],
        {},
        [
          "input",
          "emailField",
          [],
          {
            "placeholder": "enter your e-mail address",
            "type": "email",
            "name": "email"
          }
        ]
      ],
      [
        "label",
        "phoneFieldLabel",
        [
          "_hidden"
        ],
        {}
      ],
      [
        "div",
        "phoneRow",
        [
          "_row"
        ],
        {},
        [
          "div",
          "phoneField",
          [],
          {},
          [
            "span",
            null,
            [
              "_drop-list"
            ],
            {},
            [
              "input",
              "selected",
              [
                "_selected"
              ],
              {
                "type": "text",
                "name": "code",
                "data-skip-placeholder": true
              }
            ],
            [
              "span",
              null,
              [
                "_after"
              ],
              {}
            ],
            [
              "select",
              "countryCodesField",
              [],
              {
                "data-skip-placeholder": true
              }
            ]
          ],
          [
            "div",
            null,
            [
              "_forPhone"
            ],
            {},
            [
              "input",
              "phoneNumberField",
              [],
              {
                "type": "phone",
                "name": "phone"
              }
            ]
          ]
        ]
      ],
      [
        "div",
        null,
        [
          "_row",
          "_button"
        ],
        {},
        [
          "button",
          "submit",
          [],
          {}
        ],
        [
          "span",
          "notifications",
          [],
          {}
        ]
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": false
  },
  "params": {
    "tfnt": "FONT",
    "titleColor": "TEXT_COLOR",
    "fnt": "FONT",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "txt1": "TEXT_COLOR",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "bg2": "BG_COLOR_ALPHA",
    "fnt2": "FONT",
    "txt2": "TEXT_COLOR",
    "phs_txt3": "TEXT_COLOR",
    "phs_bg4": "BG_COLOR_ALPHA",
    "efnt": "FONT",
    "txtSuccess": "TEXT_COLOR",
    "txtError": "BORDER_COLOR",
    "bg1": "BG_COLOR_ALPHA",
    "labelTxt": "TEXT_COLOR",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "tfnt": "font_6",
    "titleColor": "color_15",
    "fnt": "font_9",
    "rd": "0",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "txt1": "color_15",
    "brw": "1px",
    "brd": "color_12",
    "bg2": "color_19",
    "fnt2": "font_9",
    "txt2": "color_11",
    "phs_txt3": "color_15",
    "phs_bg4": "color_18",
    "efnt": "font_9",
    "txtSuccess": "#bada55",
    "txtError": "#8b0000",
    "bg1": "color_11",
    "labelTxt": "color_12",
    "maxbrw": [
      "brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:235px;max-width:980px;max-height:1024px;",
    "%[data-is-mesh~=\"false\"] %wrapper": "position:absolute;",
    "%wrapper": "width:100%;",
    "%wrapper %formTitle": "[tfnt]    margin-bottom:4px;color:[titleColor];",
    "%wrapper label": "display:none;",
    "%wrapper %phoneField": "position:relative;",
    "%wrapper %phoneField %_forPhone": "position:absolute;display:block;left:95px;right:0;top:0;",
    "%wrapper %phoneField %_drop-list": "display:inline-block;width:86px;margin:2px 0 8px;[fnt]      position:relative;padding:0;vertical-align:top;[rd]      [shd]      background-color:transparent;overflow:hidden;white-space:nowrap;",
    "%wrapper %phoneField %_drop-list %_selected": "display:block;box-sizing:border-box;color:[txt1];[fnt]        padding:5px 1em 5px 5px;overflow:hidden;width:100%;border:[brw] solid [brd];[rd]        box-shadow:none;margin:0;",
    "%wrapper %phoneField %_drop-list %_after": "position:absolute;color:[txt1];right:[brw];padding-right:5px;font-family:Arial;font-size:.6em;[rd]        top:50%;margin-top:-1em;",
    "%wrapper %phoneField %_drop-list %_after:before": "content:\"▼\";",
    "%wrapper %phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;background-image:none;border:0;opacity:0;",
    "%wrapper div%_button": "text-align:right;vertical-align:middle;",
    "%wrapper div%_button button": "[rd]      [shd]      background-color:[bg2];[fnt2]      color:[txt2];padding:5px 10px;border:0;cursor:pointer;white-space:nowrap;display:inline-block;vertical-align:middle;margin-right:0;float:right;",
    "%wrapper div%_button button:active,%wrapper div%_button button:hover": "color:[phs_txt3];background-color:[phs_bg4];",
    "%wrapper div%_button span": "vertical-align:middle;display:none;padding:0 10px;[efnt]      text-align:left;",
    "%wrapper div%_button span%_success": "color:[txtSuccess];display:block;",
    "%wrapper div%_button span%_error": "color:[txtError];display:block;",
    "%wrapper input": "box-sizing:border-box;color:[txt1];[rd]    [shd]    background-color:[bg1];[fnt]    border:[brw] solid [brd];padding:5px;margin:2px 0 7px;width:100%;",
    "%wrapper input:invalid": "[shd]",
    "%wrapper input%_error": "border:[maxbrw] solid [txtError];color:[txtError];[fnt]",
    "%wrapper input::-webkit-input-placeholder": "color:[labelTxt];",
    "%wrapper input::-ms-input-placeholder": "color:[labelTxt];",
    "%wrapper input::placeholder": "color:[labelTxt];",
    "%[data-state~=\"left\"]": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %wrapper": "direction:rtl;text-align:right;",
    "%[data-state~=\"right\"] %wrapper div%_button": "text-align:left;",
    "%[data-state~=\"right\"] %wrapper div%_button button": "float:left;margin-left:0;margin-right:initial;",
    "%[data-state~=\"right\"] %wrapper div%_button span": "text-align:right;",
    "%[data-state~=\"right\"] %phoneField": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %phoneField %_forPhone input": "direction:ltr;text-align:right;",
    "%[data-state~=\"right\"] %phoneField %_drop-list": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %phoneField %_drop-list %_selected": "direction:ltr;text-align:right;",
    "%[data-state~=\"right\"][data-state~=\"mobile\"] %_drop-list %_selected": "padding-right:20px;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] input": "font-size:14px;padding:0 5px;margin:0 0 5px;height:45px;line-height:normal;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %_drop-list": "height:45px;margin-top:0;line-height:45px;width:90px;",
    "%[data-state~=\"mobile\"] %_drop-list %_selected": "height:45px;line-height:35px;font-size:14px;",
    "%[data-state~=\"mobile\"] %_drop-list %_after": "top:0;bottom:0;right:[brw];line-height:45px;font-size:12px;margin:0;",
    "%[data-state~=\"mobile\"] %_drop-list + input": "display:inline-block;",
    "%[data-state~=\"mobile\"] %_drop-list select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] div%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] div%_button button": "margin-top:10px;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormSkin'] = {
  "react": [
    [
      "div",
      "wrapper",
      [],
      {},
      [
        "div",
        "formTitle",
        [],
        {}
      ],
      [
        "ul",
        null,
        [],
        {},
        [
          "li",
          "firstNameRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "firstNameFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell"
            ],
            {},
            [
              "input",
              "firstNameField",
              [],
              {
                "type": "text",
                "name": "first"
              }
            ]
          ]
        ],
        [
          "li",
          "lastNameRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "lastNameFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell"
            ],
            {},
            [
              "input",
              "lastNameField",
              [],
              {
                "type": "text",
                "name": "last"
              }
            ]
          ]
        ],
        [
          "li",
          "emailRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "emailFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell"
            ],
            {},
            [
              "input",
              "emailField",
              [],
              {
                "type": "phone",
                "name": "email"
              }
            ]
          ]
        ],
        [
          "li",
          "phoneRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "phoneFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            "phoneField",
            [
              "_cell"
            ],
            {},
            [
              "div",
              null,
              [
                "_holder"
              ],
              {},
              [
                "span",
                null,
                [
                  "_drop-list"
                ],
                {},
                [
                  "input",
                  "selected",
                  [
                    "_selected"
                  ],
                  {
                    "type": "text",
                    "name": "code"
                  }
                ],
                [
                  "span",
                  null,
                  [
                    "_after"
                  ],
                  {}
                ],
                [
                  "select",
                  "countryCodesField",
                  [],
                  {}
                ]
              ],
              [
                "div",
                null,
                [
                  "_forPhone"
                ],
                {},
                [
                  "input",
                  "phoneNumberField",
                  [],
                  {
                    "type": "phone",
                    "name": "phone"
                  }
                ]
              ]
            ]
          ]
        ],
        [
          "li",
          null,
          [
            "_row"
          ],
          {},
          [
            "label",
            null,
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell",
              "_button"
            ],
            {},
            [
              "button",
              "submit",
              [],
              {}
            ],
            [
              "span",
              "notifications",
              [],
              {}
            ]
          ]
        ]
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": true
  },
  "params": {
    "fnt1": "FONT",
    "labelTxt": "TEXT_COLOR",
    "fnt": "FONT",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "txt1": "TEXT_COLOR",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "efnt": "FONT",
    "txtSuccess": "TEXT_COLOR",
    "txtError": "BORDER_COLOR",
    "bs_txt3": "TEXT_COLOR",
    "bs_bg4": "BG_COLOR_ALPHA",
    "tfnt": "FONT",
    "titleColor": "TEXT_COLOR",
    "bg2": "BG_COLOR_ALPHA",
    "fnt2": "FONT",
    "txt2": "TEXT_COLOR",
    "bg1": "BG_COLOR_ALPHA",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "fnt1": "font_7",
    "labelTxt": "#a9a9a9",
    "fnt": "font_9",
    "rd": "5px",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "txt1": "color_15",
    "brw": "0",
    "brd": "color_15",
    "efnt": "font_9",
    "txtSuccess": "#bada55",
    "txtError": "#8b0000",
    "bs_txt3": "color_15",
    "bs_bg4": "color_18",
    "tfnt": "font_6",
    "titleColor": "#a9a9a9",
    "bg2": "color_19",
    "fnt2": "font_9",
    "txt2": "color_11",
    "bg1": "color_11",
    "maxbrw": [
      "brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:235px;min-height:120px;max-width:980px;max-height:1024px;",
    "% input::-webkit-input-placeholder": "color:transparent;",
    "% input::-ms-input-placeholder": "color:transparent;",
    "% input::placeholder": "color:transparent;",
    "%wrapper": "width:100%;position:relative;",
    "%wrapper ul": "display:table;width:100%;",
    "%wrapper ul li%_row": "min-width:100%;display:table-row;",
    "%wrapper ul li%_row %_cell": "vertical-align:top;display:table-cell;position:relative;width:100%;",
    "%wrapper ul li%_row label%_cell": "[fnt1]        color:[labelTxt];border:0;vertical-align:top;text-align:right;width:110px;padding-top:5px;white-space:nowrap;",
    "%wrapper ul li%_row %_holder": "position:relative;",
    "%wrapper ul li%_row div%_cell %_drop-list": "display:inline-block;width:86px;margin:2px 0 5px;[fnt]        position:relative;padding:0;vertical-align:top;[rd]        [shd]        background-color:transparent;overflow:hidden;white-space:nowrap;",
    "%wrapper ul li%_row div%_cell %_drop-list %_selected": "display:block;box-sizing:border-box;color:[txt1];[fnt]          padding:5px 1em 5px 5px;overflow:hidden;width:100%;border:[brw] solid [brd];[rd]          box-shadow:none;margin:0;",
    "%wrapper ul li%_row div%_cell %_drop-list %_after": "position:absolute;color:[txt1];right:[brw];padding-right:5px;font-family:Arial;font-size:.6em;[rd]          top:50%;margin-top:-1em;",
    "%wrapper ul li%_row div%_cell %_drop-list %_after:before": "content:\"▼\";",
    "%wrapper ul li%_row div%_cell %_drop-list select": "position:absolute;width:100%;height:100%;top:0;background-image:none;border:0;opacity:0;",
    "%wrapper ul li%_row div%_cell%_button": "text-align:right;vertical-align:middle;",
    "%wrapper ul li%_row div%_cell%_button span": "vertical-align:middle;display:none;padding:0;[efnt]          width:100%;text-align:left;",
    "%wrapper ul li%_row div%_cell%_button span%_success": "color:[txtSuccess];display:block;",
    "%wrapper ul li%_row div%_cell%_button span%_error": "color:[txtError];display:block;",
    "%wrapper ul li%_row div%_cell%_button button:active,%wrapper ul li%_row div%_cell%_button button:hover": "color:[bs_txt3];background-color:[bs_bg4];",
    "%wrapper ul li%_row %phoneField %_forPhone": "position:absolute;display:block;left:95px;right:0;top:0;",
    "%wrapper %formTitle": "[tfnt]    margin-bottom:4px;color:[titleColor];",
    "%wrapper button": "[rd]    [shd]    background-color:[bg2];[fnt2]    color:[txt2];padding:5px 10px;border:0;cursor:pointer;display:inline-block;vertical-align:middle;white-space:nowrap;margin-top:5px;float:right;",
    "%wrapper input": "box-sizing:border-box;color:[txt1];[rd]    [shd]    background-color:[bg1];[fnt]    border:[brw] solid [brd];padding:5px;width:100%;margin:2px 0 5px;",
    "%wrapper input%_error": "border:[maxbrw] solid [txtError];color:[txtError];[fnt]",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"] %wrapper ul": "display:block;width:100%;font-size:14px;padding:0;margin:3px 0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row label%_cell": "display:block;width:100%;font-size:14px;padding:0;margin:3px 0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell": "display:block;width:100%;font-size:14px;padding:0;margin:3px 0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell input": "width:100%;font-size:14px;padding:0 5px;margin:0;height:45px;line-height:45px;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell %_drop-list": "height:45px;margin-top:0;line-height:45px;width:86px;position:relative;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell %_drop-list %_selected": "height:45px;line-height:35px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell %_drop-list %_after": "top:0;bottom:0;right:[brw];line-height:45px;font-size:12px;margin:0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell span + input": "display:inline-block;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell%_button button": "margin-top:10px;",
    "%[data-state~=\"mobile\"][data-state~=\"right\"] %wrapper ul li%_row label%_cell": "text-align:right;padding:5px 0;",
    "%[data-state~=\"mobile\"][data-state~=\"right\"] %wrapper ul li%_row div%_cell %_drop-list %_selected": "padding-right:20px;",
    "%[data-state~=\"mobile\"][data-state~=\"left\"] %wrapper ul li%_row label%_cell": "text-align:left;padding:5px 0;",
    "%[data-state~=\"right\"]": "direction:rtl;text-align:right;",
    "%[data-state~=\"right\"] %wrapper button": "float:left;",
    "%[data-state~=\"right\"] %wrapper ul li%_row div%_cell%_button": "text-align:left;",
    "%[data-state~=\"right\"] %wrapper ul li%_row div%_cell%_button span": "text-align:right;",
    "%[data-state~=\"right\"] %wrapper ul li%_row div%_cell select + input": "margin-right:23%;",
    "%[data-state~=\"right\"] %wrapper ul li%_row label%_cell": "text-align:left;padding-left:15px;",
    "%[data-state~=\"right\"] %wrapper %phoneField": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %wrapper %phoneField %_forPhone input": "direction:ltr;text-align:right;",
    "%[data-state~=\"right\"] %wrapper %phoneField %_drop-list": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %wrapper %phoneField %_drop-list %_selected": "direction:ltr;text-align:right;",
    "%[data-state~=\"left\"]": "direction:ltr;text-align:left;",
    "%[data-state~=\"left\"] %wrapper ul li%_row label%_cell": "text-align:right;padding-right:15px;",
    "%[data-state~=\"left\"] %wrapper ul li%_row div%_cell%_button span": "text-align:left;"
  }
}
 skins['wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormSkinTopLabels'] = {
  "react": [
    [
      "div",
      "wrapper",
      [],
      {},
      [
        "ul",
        null,
        [],
        {},
        [
          "li",
          null,
          [
            "_row"
          ],
          {},
          [
            "label",
            null,
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            "formTitle",
            [],
            {}
          ]
        ],
        [
          "li",
          "firstNameRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "firstNameFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell"
            ],
            {},
            [
              "input",
              "firstNameField",
              [],
              {
                "type": "text",
                "name": "first"
              }
            ]
          ]
        ],
        [
          "li",
          "lastNameRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "lastNameFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell"
            ],
            {},
            [
              "input",
              "lastNameField",
              [],
              {
                "type": "text",
                "name": "last"
              }
            ]
          ]
        ],
        [
          "li",
          "emailRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "emailFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            null,
            [
              "_cell"
            ],
            {},
            [
              "input",
              "emailField",
              [],
              {
                "type": "email",
                "name": "email"
              }
            ]
          ]
        ],
        [
          "li",
          "phoneRow",
          [
            "_row"
          ],
          {},
          [
            "label",
            "phoneFieldLabel",
            [
              "_cell"
            ],
            {}
          ],
          [
            "div",
            "phoneField",
            [
              "_cell"
            ],
            {},
            [
              "span",
              null,
              [
                "_drop-list"
              ],
              {},
              [
                "input",
                "selected",
                [
                  "_selected"
                ],
                {
                  "type": "text",
                  "name": "code"
                }
              ],
              [
                "span",
                null,
                [
                  "_after"
                ],
                {}
              ],
              [
                "select",
                "countryCodesField",
                [],
                {}
              ]
            ],
            [
              "div",
              null,
              [
                "_forPhone"
              ],
              {},
              [
                "input",
                "phoneNumberField",
                [],
                {
                  "type": "phone",
                  "name": "phone"
                }
              ]
            ]
          ]
        ],
        [
          "li",
          null,
          [
            "_row"
          ],
          {},
          [
            "div",
            null,
            [
              "_cell",
              "_button"
            ],
            {},
            [
              "button",
              "submit",
              [],
              {}
            ],
            [
              "span",
              "notifications",
              [],
              {}
            ]
          ]
        ]
      ]
    ]
  ],
  "exports": {
    "hidePlaceholders": true
  },
  "params": {
    "fnt1": "FONT",
    "labelTxt": "TEXT_COLOR",
    "efnt": "FONT",
    "txtSuccess": "TEXT_COLOR",
    "txtError": "BORDER_COLOR",
    "tl_txt3": "TEXT_COLOR",
    "tl_bg4": "BG_COLOR_ALPHA",
    "tfnt": "FONT",
    "titleColor": "TEXT_COLOR",
    "fnt": "FONT",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "txt1": "TEXT_COLOR",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "bg2": "BG_COLOR_ALPHA",
    "fnt2": "FONT",
    "txt2": "TEXT_COLOR",
    "bg1": "BG_COLOR_ALPHA",
    "maxbrw": "SIZE"
  },
  "paramsDefaults": {
    "fnt1": "font_7",
    "labelTxt": "#a9a9a9",
    "efnt": "font_9",
    "txtSuccess": "#bada55",
    "txtError": "#8b0000",
    "tl_txt3": "color_15",
    "tl_bg4": "color_18",
    "tfnt": "font_6",
    "titleColor": "#a9a9a9",
    "fnt": "font_9",
    "rd": "5px",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "txt1": "color_15",
    "brw": "0",
    "brd": "color_15",
    "bg2": "color_19",
    "fnt2": "font_9",
    "txt2": "color_11",
    "bg1": "color_11",
    "maxbrw": [
      "brw"
    ]
  },
  "paramsMutators": {
    "maxbrw": {
      "type": "max",
      "value": 1,
      "param": "brw"
    }
  },
  "css": {
    "%wrapper %_hidden": "display:none !important;",
    "% input": "-webkit-appearance:none;-moz-appearance:none;",
    "%_message": "display:none;",
    "%": "min-width:235px;min-height:120px;max-width:980px;max-height:1024px;",
    "% input::-webkit-input-placeholder": "color:transparent;",
    "% input::-ms-input-placeholder": "color:transparent;",
    "% input::placeholder": "color:transparent;",
    "%wrapper": "width:100%;",
    "%wrapper ul": "width:100%;",
    "%wrapper ul li%_row": "min-width:100%;",
    "%wrapper ul li%_row%_phone": "position:relative;",
    "%wrapper ul li%_row %_cell": "display:block;position:relative;",
    "%wrapper ul li%_row label%_cell": "[fnt1]        color:[labelTxt];border:0;vertical-align:middle;text-align:left;padding:3px 0;",
    "%wrapper ul li%_row div%_cell%_button": "text-align:right;vertical-align:middle;",
    "%wrapper ul li%_row div%_cell%_button span": "vertical-align:middle;display:none;padding:0 10px;[efnt]          text-align:left;",
    "%wrapper ul li%_row div%_cell%_button span%_success": "color:[txtSuccess];display:block;",
    "%wrapper ul li%_row div%_cell%_button span%_error": "color:[txtError];display:block;",
    "%wrapper ul li%_row div%_cell%_button button:active,%wrapper ul li%_row div%_cell%_button button:hover": "color:[tl_txt3];background-color:[tl_bg4];",
    "%wrapper %formTitle": "[tfnt]    margin-bottom:4px;color:[titleColor];",
    "%wrapper %phoneField": "position:relative;",
    "%wrapper %phoneField %_drop-list": "display:inline-block;width:86px;[fnt]      position:relative;padding:0;vertical-align:top;[rd]      [shd]      background-color:transparent;overflow:hidden;white-space:nowrap;margin-bottom:2px;",
    "%wrapper %phoneField %_drop-list %_selected": "display:block;box-sizing:border-box;color:[txt1];[fnt]        padding:5px 1em 5px 5px;overflow:hidden;width:100%;border:[brw] solid [brd];[rd]        box-shadow:none;margin:0;",
    "%wrapper %phoneField %_drop-list %_after": "position:absolute;color:[txt1];right:[brw];padding-right:5px;font-family:Arial;font-size:.6em;[rd]        top:50%;margin-top:-1em;",
    "%wrapper %phoneField %_drop-list %_after:before": "content:\"▼\";",
    "%wrapper %phoneField %_drop-list select": "position:absolute;width:100%;height:100%;top:0;background-image:none;border:0;opacity:0;",
    "%wrapper %phoneField %_forPhone": "position:absolute;display:block;left:95px;right:0;top:0;",
    "%wrapper %phoneField %_forPhone input": "margin:0;",
    "%wrapper button": "[rd]    [shd]    background-color:[bg2];[fnt2]    color:[txt2];padding:5px 10px;border:0;cursor:pointer;display:inline-block;white-space:nowrap;vertical-align:middle;margin:8px 0 0;float:right;",
    "%wrapper input": "box-sizing:border-box;color:[txt1];[rd]    [shd]    background-color:[bg1];[fnt]    border:[brw] solid [brd];padding:5px;width:100%;",
    "%wrapper input%_error": "border:[maxbrw] solid [txtError];color:[txtError];[fnt]",
    "%[data-state~=\"left\"]": "direction:ltr;text-align:left;",
    "%[data-state~=\"left\"] %wrapper ul li%_row label%_cell": "text-align:left;",
    "%[data-state~=\"right\"]": "direction:rtl;text-align:right;",
    "%[data-state~=\"right\"] %wrapper ul li%_row div%_cell%_button span": "text-align:right;",
    "%[data-state~=\"right\"] %wrapper ul li%_row div%_cell%_button": "text-align:left;",
    "%[data-state~=\"right\"] %wrapper ul li%_row div%_cell select + input": "margin-right:23%;",
    "%[data-state~=\"right\"] %wrapper ul li%_row label%_cell": "text-align:right;padding:0 0 5px 15px;",
    "%[data-state~=\"right\"] %wrapper button": "float:left;",
    "%[data-state~=\"right\"] %wrapper %phoneField": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %wrapper %phoneField %_forPhone input": "direction:ltr;text-align:right;",
    "%[data-state~=\"right\"] %wrapper %phoneField %_drop-list": "direction:ltr;text-align:left;",
    "%[data-state~=\"right\"] %wrapper %phoneField %_drop-list %_selected": "direction:ltr;text-align:right;padding-right:20px;",
    "%[data-state~=\"mobile\"]": "min-width:initial;min-height:initial;max-width:initial;max-height:initial;",
    "%[data-state~=\"mobile\"][data-state~=\"right\"] ul li%_row div%_cell %_drop-list %_selected": "padding-right:20px;",
    "%[data-state~=\"mobile\"][data-state~=\"right\"] %wrapper ul li%_row label%_cell": "text-align:right;",
    "%[data-state~=\"mobile\"][data-state~=\"left\"] %wrapper ul li%_row label%_cell": "text-align:left;",
    "%[data-state~=\"mobile\"] %wrapper ul": "display:block;width:100%;font-size:14px;padding:0;margin:3px 0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row": "display:block;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row label%_cell": "display:block;width:100%;font-size:14px;margin:3px 0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell": "display:block;width:100%;font-size:14px;padding:0;margin:3px 0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell input": "width:100%;font-size:14px;padding:0 5px;margin:0;height:45px;line-height:45px;-webkit-appearance:none;-moz-appearance:none;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell %_drop-list": "height:45px;margin-top:0;line-height:45px;width:86px;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell %_drop-list %_selected": "height:45px;line-height:35px;font-size:14px;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell %_drop-list %_after": "top:0;bottom:0;right:[brw];line-height:45px;font-size:12px;margin:0;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell span + input": "display:inline-block;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell select": "font-size:14px;height:45px;line-height:45px;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell%_button span": "display:block;text-align:center;padding:0;width:100%;",
    "%[data-state~=\"mobile\"] %wrapper ul li%_row div%_cell%_button button": "margin-top:10px;"
  }
}

        return skins;
    }));